import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { IBank } from 'safe'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import SelectOfCategories from '../../components/Inputs/SelectOfCategories'
import { TextArea } from '../../components/Inputs/TextArea'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { fectchAccounts, updateAccount } from '../../redux/actions/accounts'
import { RootState } from '../../redux/store'
import { docs } from '../../userConfig'
import { bankAccountType } from './CreateAccountForm'

const EditAccountForm: React.FC<EditFormProps> = ({
  banks,
  editingAccount,
  onCancel,
}) => {
  const { addAlert } = useSnackBars()

  const currencies = useSelector((state: RootState) => state.curr.currencies)

  const dispatch = useDispatch()
  console.log('editingAccount: ', editingAccount)
  const form = useForm({
    defaultValues: {
      ...editingAccount,
    },
  })

  const [selectedCurrency, setSelectedCurrency] = useState<any|null>(null)

  const [currenciesValues, setCurrenciesValues] = useState< { text: string; value: string | number }[]>([])

  useEffect(() => {
    if (currencies.length > 0) {
      setCurrenciesValues(currencies.map(v => ({text: v?.name, value: v?.id+""})))
    }
  }, [])

  useEffect(() => {
    if (currencies?.length > 0 && editingAccount) {
      let currency = currencies.find(
        (currency) => currency.id === editingAccount?.idCurrency
      )
      // console.log("LLEGA...", currency)
      setSelectedCurrency(currency)
    }
  }, [currencies, editingAccount])

  useEffect(() => {
    // console.log("SELECTED CURRENCY", selectedCurrency)
  }, [selectedCurrency])

  // const [showBankTransfer, setShowBankTransfer] = useState<boolean>(() => editingAccount.bankAccountNumber ? true : false)
  // const [showPagoMovil, setShowPagoMovil] = useState<boolean>(() => editingAccount.mobilePaymentPhone ? true : false)
  // const [showCardSwiper, setShowCardSwiper] = useState<boolean>(() => editingAccount.cardSwiperNumber ? true : false)

  const handleSubmit = async (values) => {
    // console.log('values', values)
    addAlert({
      message: 'Actualizando cuenta...',
      status: 'loading',
    })
    console.log("VALUES", selectedCurrency)
    try {
      const basic_account = {
        ...editingAccount,
        ...values,
        document: {
          document: values.document,
          documentType: values.documentType,
        },
        currency: {
          id: selectedCurrency?.id
        } 
      }
      // if (!showBankTransfer) basic_account.bankAccountNumber = ''
      // if (!showPagoMovil) basic_account.mobilePaymentPhone = ''
      // if (!showCardSwiper) basic_account.cardSwiperNumber = ''

      await dispatch(updateAccount(basic_account))
      await dispatch(fectchAccounts())
      addAlert({
        message: 'Cuenta actualizada con éxito',
        status: 'success',
      })
      onCancel()
    } catch (error: any) {
      console.log('error: ', error)
      addAlert({
        message:
          error?.response?.data?.message ||
          'Error al actualizar cuenta bancaria',
        status: 'error',
      })
    }
  }

  return (
    <Form
      form={form}
      onSubmit={(values) => handleSubmit(values)}
      classes={`gap-x-6 gap-y-2`}
      style={{ width: '100%' }}
    >
      <h2 className="col-span-12 mt-1 text-primary-900 font-bold dark:text-white">
        Editar Cuenta
      </h2>
      {editingAccount.accountType === 'CASH' && (
        <>
           <FormItem
            name="idCurrency"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
            defaultValue={currenciesValues.find(v => v.value === editingAccount?.idCurrency)}
          >
            <SelectOfCategories
              // value={currenciesValues}
              onChange={(value) => {
                // console.log("VALUE...", value)
                // console.log("VAL CRRENCYES", currencies)
                if (value?.value) {
                  let currency = currencies?.find(
                    (currency) => currency?.id === value?.value
                  )
                  setSelectedCurrency(currency)
                }
                // let currencySelected = value
                // setSelectedCurrency(value)
              }}
              options={currenciesValues}
              label="Moneda"
              // setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>


          <FormItem
            name="description"
            classes="col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <TextArea
              label="Nombre de la cuenta"
              placeholder="Ingresar datos de la cuenta"
              maxLength={255}
            />
          </FormItem>
        </>
      )}

      {editingAccount.accountType === 'OTHER' && (
        <>
          <FormItem
            name="owner"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-4 col-span-12"
          >
            <InputText small label="Nombre Titular" maxLength={255} />
          </FormItem>

          <FormItem
            name="accountNumber"
            classes="xl:col-span-4 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <InputText small label="Nro. Cuenta / Coordenada" maxLength={255} />
          </FormItem>

          <FormItem
            name="idCurrency"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
            defaultValue={currenciesValues.find(v => v.value === editingAccount?.idCurrency)}
          >
            <SelectOfCategories
              // value={currenciesValues}
              onChange={(value) => {
                // console.log("VALUE...", value)
                // console.log("VAL CRRENCYES", currencies)
                if (value?.value) {
                  let currency = currencies?.find(
                    (currency) => currency?.id === value?.value
                  )
                  setSelectedCurrency(currency)
                }
                // let currencySelected = value
                // setSelectedCurrency(value)
              }}
              options={currenciesValues}
              label="Moneda"
              // setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>


          <FormItem
            name="description"
            classes="col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <TextArea
              label="Nombre de la cuenta"
              placeholder="Ingresar datos de la cuenta"
              maxLength={255}
            />
          </FormItem>
        </>
      )}

      {editingAccount.accountType === 'BANK_ACCOUNT' && (
        <>
          <FormItem
            // defaultValue={bankAccountType[0]}
            name="bankAccountType"
            classes="xl:col-span-3 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
            defaultValue={{
              value:
                bankAccountType.find(
                  (acc) => acc.value === editingAccount.bankAccountType
                )?.value || 'SAVING',
              text:
                bankAccountType.find(
                  (acc) => acc.value === editingAccount.bankAccountType
                )?.text || 'Ahorro',
            }}
          >
            <Select options={bankAccountType} label="Tipo de cuenta" />
          </FormItem>

          <FormItem
            name="bank.id"
            classes="xl:col-span-4 col-span-12"
            defaultValue={{
              value:
                banks.find(
                  (bank) => +bank.id === +(editingAccount.bank?.id || 1)
                )?.id || '1',
              text:
                banks.find(
                  (bank) => +bank.id === +(editingAccount.bank?.id || 1)
                )?.name || 'BANCO X',
            }}
          >
            <Select
              options={banks.map((bank) => ({
                value: bank.id,
                text: bank.name,
              }))}
              label="Banco"
              // setSelectedHelper={setBan}
            />
          </FormItem>

          <FormItem
            name="description"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-5 col-span-12"
          >
            <InputText small label="Nombre de la cuenta" maxLength={255} />
          </FormItem>

          <FormItem
            // defaultValue={docs[0]}
            name="documentType"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-2 col-span-4"
            defaultValue={{
              value:
                docs.find((doc) => doc.value === editingAccount?.documentType)
                  ?.value || 'V',
              text:
                docs.find((doc) => doc.value === editingAccount.documentType)
                  ?.text || 'V',
            }}
          >
            <Select
              options={docs}
              label="Tipo"
              // setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>

          <FormItem
            name="document"
            classes="xl:col-span-4 col-span-8"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Documento inválido' },
              minLength: {
                value: 6,
                message: 'El documento debe de poseer al menos 6 caracteres.',
              },
            }}
          >
            <InputText label="Documento" maxLength={10} />
          </FormItem>

          <FormItem
            name="owner"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Nombre Titular" maxLength={255} />
          </FormItem>

          {/* <FormItem
            name="description"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-5 col-span-12"
          >
            <InputText small label="Nombre de la cuenta" maxLength={255} />
          </FormItem> */}

          <FormItem
            name="idCurrency"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
            defaultValue={currenciesValues.find(v => v.value === editingAccount?.idCurrency)}
          >
            <SelectOfCategories
              // value={currenciesValues}
              onChange={(value) => {
                // console.log("VALUE...", value)
                // console.log("VAL CRRENCYES", currencies)
                if (value?.value) {
                  let currency = currencies?.find(
                    (currency) => currency?.id === value?.value
                  )
                  setSelectedCurrency(currency)
                }
                // let currencySelected = value
                // setSelectedCurrency(value)
              }}
              options={currenciesValues}
              label="Moneda"
              // setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>

          <h3 className="col-span-12 my-1 text-primary-900 font-bold dark:text-white">
            Métodos de Pago
          </h3>

          <div className="xl:col-span-4 col-span-12 flex flex-col">
            {/* <Switch
              value={showBankTransfer}
              label="Transferencia"
              small={true}
              onChange={setShowBankTransfer}
              containerClasses="mb-2"
            ></Switch>

            {showBankTransfer && ( */}
            <FormItem
              name="bankAccountNumber"
              // classes="xl:col-span-4 col-span-12"
              rules={{
                // required: 'Es necesaria un número de cuenta',
                minLength: {
                  value: 20,
                  message: 'El número de cuenta debe poseer 20 dígitos',
                },
                maxLength: {
                  value: 20,
                  message: 'El número de cuenta debe poseer 20 dígitos',
                },
              }}
            >
              <InputText
                small
                phone={true}
                label="Número de cuenta"
                maxLength={20}
              />
            </FormItem>
            {/* )} */}
          </div>

          <div className="xl:col-span-4 col-span-12 flex flex-col">
            {/* <Switch
              value={showPagoMovil}
              label="Pago Móvil"
              small={true}
              onChange={setShowPagoMovil}
              containerClasses="mb-2"
            ></Switch>

            {showPagoMovil && ( */}
            <FormItem
              name="mobilePaymentPhone"
              // classes="xl:col-span-4 col-span-12"
              rules={
                {
                  // pattern: {
                  //   value: phoneNumberRegex,
                  //   message: 'El número telefónico ingresado debe ser válido',
                  // },
                }
              }
            >
              <InputText
                isUpperValue={false}
                small
                label="Teléfono (Pago móvil)"
                maxLength={255}
              />
            </FormItem>
            {/* )} */}
          </div>

          <div className="xl:col-span-4 col-span-12 flex flex-col">
            {/* <Switch
              value={showCardSwiper}
              label="Punto de Venta"
              small={true}
              onChange={setShowCardSwiper}
              containerClasses="mb-2"
            ></Switch>

            {showCardSwiper && ( */}
            <FormItem
              name="cardSwiperNumber"
              classes="xl:col-span-4 col-span-12"
            >
              <InputText
                isUpperValue={false}
                small
                label="Serial (Punto de venta)"
                maxLength={255}
              />
            </FormItem>
            {/* )} */}
          </div>
        </>
      )}

      <div className="col-span-12 h-full flex flex-row mt-5">
        <div className="w-1/2 mr-5 pl-1">
          <Button onClick={() => onCancel()} type="outline" classes="w-full">
            Cancelar
          </Button>
        </div>
        <div className="w-1/2 pr-1">
          <Button type="primary" classes="w-full" htmlType="submit">
            Guardar cambios
          </Button>
        </div>
      </div>
    </Form>
  )
}

interface EditFormProps {
  banks: IBank[]
  editingAccount: any
  onCancel: Function
}

export default EditAccountForm
